// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.date-style {\n  font-size: small;\n  color: #909194;\n}\n.message-list-item > div {\n  height: auto !important;\n  text-wrap: normal;\n}\n.message-list-subtitle {\n  white-space: normal;\n  text-align: justify;\n}\n", ""]);
// Exports
module.exports = exports;
